import { Box, Typography } from "@mui/material";
import { cashiLogo } from "../../include/cashiBrand";
import { indiaDateTime } from "../../include/indiaDate";
import { consoleColors, headingCase } from "../admin/consoleTheme";

export default function EventEnded({ title, upcoming = false, startsAt = "" }) {
  return (
    <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", px: 2, py: 4, background: consoleColors.sidebar }}>
      <Box sx={{ width: "100%", maxWidth: 480, textAlign: "center", color: "#fff" }}>
        <Box component="img" src={cashiLogo} alt="Cashi" sx={{ height: 36, width: "auto", mb: 2 }} />
        <Box sx={{ width: 92, height: 92, mx: "auto", borderRadius: "50%", background: "rgba(255,255,255,0.18)", display: "grid", placeItems: "center", fontSize: 42, border: "3px solid rgba(255,255,255,0.75)" }}>✓</Box>
        <Typography sx={{ fontSize: { xs: 32, sm: 42 }, fontWeight: 900, lineHeight: 1.1, mt: 2 }}>{upcoming ? "This event has not started" : "This event has ended"}</Typography>
        {title ? <Typography sx={{ fontSize: 18, mt: 1.4, opacity: 0.95 }}>{headingCase(title)}</Typography> : null}
        {upcoming && startsAt ? <Typography sx={{ fontSize: 16, mt: 1, color: consoleColors.navText }}>Opens {indiaDateTime(startsAt)}</Typography> : null}
        <Typography sx={{ fontSize: 18, mt: 1.2, color: consoleColors.navText }}>{upcoming ? "Please come back when the event opens" : "Thank you for participating"}</Typography>
      </Box>
    </Box>
  );
}
